import { Link, NavLink, useNavigate } from "react-router-dom";
import { removeCookie } from "../../utils/cookies.js";
import toast from "../../utils/toast.js";

export default function Sidebar({ isOpen, onClose }) {
  const navigate = useNavigate();

  function handleLogout() {
    removeCookie("token");
    removeCookie("user");
    toast.success("Logged out successfully.");
    navigate("/login_fleetowner");
  }

  return (
    <>
      <aside className={`dash-sidebar${isOpen ? " open" : ""}`} id="dashSidebar">
        <div className="sidebar-top">
          <Link to="/panel" className="brand" onClick={onClose}>
            <img
              src="/assets/panel/images/logo.svg"
              alt="RouteRider logo"
              className="brand-logo"
            />
            <span className="brand-name light">
              Route<span className="accent-text">Rider</span>
            </span>
          </Link>
          <button
            type="button"
            className="sidebar-close"
            id="sidebarClose"
            aria-label="Close menu"
            onClick={onClose}
          >
            ×
          </button>
        </div>
        <nav className="sidebar-nav">
          <p className="sidebar-label">Menu</p>
          <NavLink
            to="/panel"
            end
            onClick={onClose}
            className={({ isActive }) =>
              `sidebar-link${isActive ? " active" : ""}`
            }
          >
            <span className="sidebar-icon">🏠</span> Overview
          </NavLink>
          <NavLink
            to="/panel/cars"
            onClick={onClose}
            className={({ isActive }) =>
              `sidebar-link${isActive ? " active" : ""}`
            }
          >
            <span className="sidebar-icon">🚗</span> My Cars
          </NavLink>
     
          <p className="sidebar-label">Account</p>
          <NavLink
            to="/panel/profile"
            onClick={onClose}
            className={({ isActive }) =>
              `sidebar-link${isActive ? " active" : ""}`
            }
          >
            <span className="sidebar-icon">👤</span> Profile
          </NavLink>
        </nav>
        <div className="sidebar-bottom">
          <button
            type="button"
            className="sidebar-link"
            id="logoutBtn"
            onClick={handleLogout}
          >
            <span className="sidebar-icon">🚪</span> Log out
          </button>
        </div>
      </aside>
    </>
  );
}

